<template>
  <div class="vx-row match-height">
    <div class="vx-col w-full">
      <vx-card>
        <vs-tabs vs-alignment="fixed" alignment="fixed">
          <vs-tab :label="$t('SalesPartnersPlans')">
            <sales-partners-plans></sales-partners-plans>
          </vs-tab>
          <vs-tab :label="$t('AssignProductToSegment')">
            <assign-product-to-segment></assign-product-to-segment>
          </vs-tab>
          <vs-tab :label="$t('AssignSegmentToProduct')">
            <assign-segment-to-product></assign-segment-to-product>
          </vs-tab>
          <vs-tab :label="$t('FindSegmentForProduct')">
            <find-segment-for-product></find-segment-for-product>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import SalesPartnersPlans from "./SalesPartnerPlan/Index.vue";
import AssignProductToSegment from "./AssignProductToSegment/Index.vue";
import AssignSegmentToProduct from "./AssignSegmentToProduct/Index.vue";
import FindSegmentForProduct from "./FindSegmentForProduct/Index.vue";

import "@/assets/scss/vuesax-rtl/pages/_custom.scss";

export default {
  name: "saleManagement_BasicDefinitions_Index",
  components: {
    SalesPartnersPlans,
    AssignProductToSegment,
    AssignSegmentToProduct,
    FindSegmentForProduct
  }
};
</script>
